/**
 * @generated SignedSource<<c3568e3505ceff7298426338a8ec155c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamNavigator_home$data = {
  readonly __typename: string;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_home" | "TeamHomeNavigator_home">;
  readonly " $fragmentType": "TeamNavigator_home";
};
export type TeamNavigator_home$key = {
  readonly " $data"?: TeamNavigator_home$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamNavigator_home">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamNavigator_home",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_home"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHomeNavigator_home"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "HomeUnion",
  "abstractKey": "__isHomeUnion"
};

(node as any).hash = "8f4c43d9009f2680c7187fce7b71575f";

export default node;
